import React from 'react';
import { useIntl } from 'react-intl';
import { Typography } from 'shared/components';

export const ConsentToMarketingCommunicationsTooltip = () => {
  const { formatMessage } = useIntl();
  return <Typography variant="body2">{formatMessage({ id: 'consentMarketingCommunication' })}</Typography>;
};

export const ConsentDataProcessingLocatorPROServicesTooltip = () => {
  const { formatMessage } = useIntl();
  return (
    <>
      <Typography variant="h6" gutterBottom>
        <b>LocatorPRO Planner:</b>
      </Typography>
      <Typography gutterBottom variant="body2">
        <span dangerouslySetInnerHTML={{ __html: formatMessage({ id: 'consentData.tooltip.text.pro.planer' }) }} />
      </Typography>

      <Typography variant="h6" gutterBottom>
        <b>LocatorPRO GPS:</b>
      </Typography>
      <Typography variant="body2">
        <span dangerouslySetInnerHTML={{ __html: formatMessage({ id: 'consentData.tooltip.text.gps' }) }} />
      </Typography>
    </>
  );
};
